import {Button, Card, CardBody, CardFooter, CardHeader, Checkbox, Input, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import Validator from "../helper/validator/Validator";
import {ValidatorProvider} from "../helper/validator/ValidatorContext";
import {Toaster} from "../helper/Toaster";
import {registerService} from "../services/user/register";
import {toast} from "react-toastify";
import OtpField from "../components/system/otpField";
import PasswordField from "../components/system/passwordField";
import {checkAll} from "../helper/validator/Check";
import authManager from "../helper/AuthHelper";

const Register = () => {
  const backgroundPhoto = '/assets/login-background.jpeg';
  const [name, setName] = useState("");
  const [family, setFamily] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmationCode, setConfirmationCode] = useState("");
  const [, setCodeSent] = useState(false);
  const [referralCode, setReferralCode] = useState("");

  const [isChecked, setIsChecked] = useState(false)
  const [termsAccepted, setTermsAccepted] = useState(false)
  const [showValidationErrors, setShowValidationErrors] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (localStorage.getItem('userInfo')) {
      if (localStorage.getItem('expiration')) {
        if (localStorage.getItem('token')) {
          window.location.href = "/";
        }
      }
    }
  }, []);

  useEffect(() => {
    const url = window.location.search;
    let params = new URLSearchParams(url);
    if (params.has('referral')) {
      setReferralCode(params.get('referral'));
    }
  }, []);


  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading) return; // Prevent multiple simultaneous requests
    
    if (password !== confirmPassword) {
      Toaster.failure(null, <Typography variant={"small"}>
        رمز ورود با تکرار رمز عبور برابر نیست
      </Typography>);
      return
    }

    const res = checkAll();

    if (!res) {
      setIsChecked(true);
      setShowValidationErrors(true);
      Toaster.failure(null, (
        <Typography variant="small">
          مقادیر الزامی را بر اساس راهنما تکمیل کنید
        </Typography>
      ));
      return;
    }

    // Reset validation display after successful validation
    setIsChecked(false);
    setShowValidationErrors(false);

    if (!termsAccepted) {
      Toaster.failure(null, (
        <Typography variant="small">
          پذیرش قوانین الزامی است
        </Typography>
      ));
      return;
    }

    const data = {
      name: name.trim(),
      family: family.trim(),
      phone: phone.trim(),
      password: password,
      code: confirmationCode.trim(),
      referral_code: referralCode.trim()
    };

    try {
      setLoading(true);
      const result = await registerService(data);

      if (result.status === 201) {
        authManager.loginHandler(result.data);
        toast.success("ثبت نام با موفقیت انجام شد", {
          position: "top-right",
          closeOnClick: true
        });
        window.location.href = "/";
      } else {
        // Show API error, not validation error
        setShowValidationErrors(false);
        Toaster.failure(null, (
          <Typography variant="small">
            {result.data?.message || 'خطا در ثبت نام'}
          </Typography>
        ));
      }
    } catch (err) {
      Toaster.failure(null, (
        <Typography variant="small">
          {err.message || 'خطا در ثبت نام'}
        </Typography>
      ));
      console.error('Registration error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ValidatorProvider>
      <form onSubmit={handleSubmit} className={"flex justify-center items-center h-screen"} style={{backgroundImage: `url(${backgroundPhoto})`}}>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <Card className="flex w-full mx-4 md:w-2/3">
          <CardHeader variant="gradient" color="gray" className="mb-4 pt-4 grid place-items-center">
            <Typography variant="h3" color="white" className="pt-4 mb-4">
              ثبت نام
            </Typography>
          </CardHeader>
          <CardBody className="flex flex-col gap-4 py-8 px-4">
            <Input variant="standard" label="* نام" size="lg" value={name} onChange={(e) => setName(e.target.value)}/>
            <Validator state={name.trim()} isChecked={isChecked} rules="required|minLength=3|maxLength=50"/>
            <Input variant="standard" label="نام خانوادگی" size="lg" value={family}
                   onChange={(e) => setFamily(e.target.value)}/>
            <Validator state={family.trim()} isChecked={isChecked} rules="required|minLength=3|maxLength=50"/>
            <Input variant="standard" label="شماره همراه" size="lg" value={phone}
                   onChange={(e) => setPhone(e.target.value)}/>
            <Validator state={phone.trim()} isChecked={isChecked} rules="required|mobile|num|len=11"/>
            <PasswordField label="رمز ورود" size="lg" onChange={setPassword}/>
            <Validator state={password} isChecked={isChecked} rules="required|minLength=8"/>
            <PasswordField label="تکرار رمز ورود" size="lg" onChange={setConfirmPassword}/>
            <Validator state={confirmPassword} isChecked={isChecked} rules={`required|matches=${password}`}/>
            <OtpField time={300} onChange={setConfirmationCode} userPhone={phone} setCodeSent={setCodeSent}/>
            <Validator state={confirmationCode.trim()} isChecked={isChecked} showError={showValidationErrors} rules="required|num|minLength=4|maxLength=6"/>
            <Input variant="standard" label="کد معرف" size="lg" value={referralCode}
                   onChange={(e) => setReferralCode(e.target.value)}/>
            <div className="flex flex-row -ml-2.5">
              <Checkbox className="flex-col -mt-2" checked={termsAccepted}
                        onChange={() => setTermsAccepted(!termsAccepted)}/>
              <Typography className="flex-col">
                <a className="underline" href="https://mymobasher.com/terms/">شرایط و قوانین سایت</a> را
                خوانده و می‌پذیرم
              </Typography>
            </div>
          </CardBody>
          <CardFooter className="pt-0">

            <Button type="submit" variant="gradient" fullWidth className="mb-4" disabled={!termsAccepted || loading}>
              {loading ? 'در حال ثبت نام...' : 'ثبت نام'}
            </Button>
            <Typography variant="small" className="mt-6 flex justify-center">
              قبلا ثبت‌نام کردی؟ <a href="/login" className="mx-2 font-bold">ورود</a>
            </Typography>
          </CardFooter>
        </Card>
        {/*<Validator ref={validatorRef} />*/}
      </form>
    </ValidatorProvider>
  );
};

export default Register;
